import {FC} from 'react';
import Wrapper from './SectionWrapper';
import StaticImageUploader from './StaticImageUploader';

interface HomeProps{
    details:any,
    bannerRedirectionUrl:string
}

const Home:FC<HomeProps> = ({details, bannerRedirectionUrl}) => {
console.log(details,"Home")
    return <Wrapper title={"Home Image"}>
        <StaticImageUploader bannerRedirectionUrl={bannerRedirectionUrl} details={details[0]} />
    </Wrapper>
};

export default Home